// src/hooks/nationalities/useRestoreNationality.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreNationality as restoreNationalityAPI } from "../../api/apiNationalities";
import parseError from "../../utils/parseError";

const useRestoreNationality = () => {
    const queryClient = useQueryClient();

    const { mutate: restore, isPending: isRestoring } = useMutation({
        mutationFn: restoreNationalityAPI,
        onSuccess: (res) => {
            const message = res?.message || "Nationality restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["nationalities"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore nationality");
        },
    });

    return { restoreNationality: restore, isRestore: isRestoring };
};

export default useRestoreNationality;